import { RootState } from 'appReducer'

export interface LocationPaymentStatus {
    stripeIDStatus: boolean | undefined
    paymentsRatesStatus: boolean | undefined
    allFieldsCompleted: boolean | undefined
    isTrainingComplete: boolean | undefined
}

export function selectLocationById(
    state: RootState,
    practiceId: string,
    locationId: string,
): Models.PracticeLocation | undefined {
    const practice = state.practices.practices[practiceId]
    if (!practice?.locations) return undefined

    return practice.locations.find(loc => loc.id === locationId)
}

export function selectLocationPaymentStatus(
    state: RootState,
    practiceId: string,
    locationId: string,
): LocationPaymentStatus {
    const location = selectLocationById(state, practiceId, locationId)

    if (!location) {
        return {
            stripeIDStatus: undefined,
            paymentsRatesStatus: undefined,
            allFieldsCompleted: undefined,
            isTrainingComplete: undefined,
        }
    }

    return {
        stripeIDStatus: location.stripeID,
        paymentsRatesStatus: location.paymentsRates,
        allFieldsCompleted: location.allFieldsCompleted,
        isTrainingComplete: location.isTrainingComplete,
    }
}

export function selectLocationTrainingStatus(
    state: RootState,
    practiceId: string,
    locationId: string,
): boolean | undefined {
    const location = selectLocationById(state, practiceId, locationId)
    return location?.isTrainingComplete
}

export function selectPractice(
    state: RootState,
    practiceId: string,
): Models.Practice | undefined {
    return state.practices.practices[practiceId]
}

export function selectPracticeLocations(
    state: RootState,
    practiceId: string,
): Models.PracticeLocation[] {
    const practice = state.practices.practices[practiceId]
    return practice?.locations || []
}

export function selectLocationListMetadata(
    state: RootState,
    practiceId: string,
): { page: number; allPages: number; allRows: number; search: string } {
    const practiceLocations = state.practiceLocations[practiceId]
    return practiceLocations?.metadata || { page: 1, allPages: 1, allRows: 0, search: '' }
}

export function selectLocationModals(state: RootState, practiceId: string) {
    return state.practiceLocations[practiceId]?.modals
}

export function selectLocationMessages(state: RootState, practiceId: string) {
    const practiceLocations = state.practiceLocations[practiceId]
    return {
        successMessage: practiceLocations?.successMessage || '',
        errorMessage: practiceLocations?.errorMessage || '',
    }
}

export function selectIsFetchingAllPracticeLocations(
    state: RootState,
    practiceId: string,
): boolean {
    return state.practices.isFetchingAllPracticeLocations[practiceId] || false
}

export function selectIsSavingPracticeLocationProducts(state: RootState): boolean {
    return state.practices.isSavingPracticeLocationProducts || false
}
